export function toTitleCaseRegex(str: string) {
  // 1. Ensure the whole string is lowercase first
  // 2. Use a regex to find all word boundaries (\b) followed by a word character (\w)
  return str.toLowerCase().replace(/\b\w/g, char => {
    // Replace the matched character with its uppercase version
    return char.toUpperCase();
  });
}